import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
     India Interlock Bricks (c) 2022
    </span>
    <div class="socials">
    </div>
  `,
})
export class FooterComponent {
}
